import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { XCircle } from 'lucide-react';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-muted/30">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <XCircle className="w-16 h-16 mx-auto text-destructive" />
          <CardTitle className="font-heading text-2xl mt-4">
            Payment Cancelled
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            Your payment was cancelled. No charges have been made to your account.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button 
              onClick={() => navigate('/pricing')}
              className="bg-lime-500 hover:bg-lime-600 text-white"
              data-testid="try-again"
            >
              Try Again
            </Button>
            <Button 
              variant="outline"
              onClick={() => navigate('/dashboard')}
              data-testid="go-to-dashboard"
            >
              Go to Dashboard
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
